import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { customTitleWrapperStyles, headlineIconWrapperStyles } from '../MainContent.styles';

const ContentHeadline = ({ iconName: IconComponent = InfoIcon, iconNode, controls, title }) => (
  <Box
    className="flex items-center justify-between my-4 title-wrapper"
    sx={customTitleWrapperStyles}
  >
    <Typography className="title flex" component="h5" variant="bold16">
      <Box sx={headlineIconWrapperStyles}>{iconNode ?? <IconComponent />}</Box>
      {title}
    </Typography>

    {controls}
  </Box>
);

ContentHeadline.propTypes = {
  title: PropTypes.string.isRequired,
  iconName: PropTypes.elementType,
  iconNode: PropTypes.node,
  controls: PropTypes.node,
};

export default memo(ContentHeadline);
